import { useParams } from "react-router-dom"

import { TEventDetail } from "@letshang/constants"
import { get } from "lodash-es"

import { useEventDetails } from "@api/services/events/useEventsApi"

import AbstractcardOfTicket from "../Components/AbstractcardOfTicket"

const TicketCollection = () => {
  const params = useParams()
  const eventId = get(params, "eventId", "")
  const { data, isLoading: eventLoading } = useEventDetails(eventId)

  const currentEventDetails = get(data, "data", {}) as TEventDetail

  const myBoughtTickets = get(currentEventDetails, "myTickets", [])

  return (
    <div className="mb-6">
      {myBoughtTickets?.map((item, _) => {
        return (
          <div key={_} className="mt-8">
            <AbstractcardOfTicket
              ticketDetail={{
                id: item?.attendee || "",
              }}
              eventDetail={{
                eventName: currentEventDetails?.eventDocData?.eventName,
                eventId: currentEventDetails?.eventId,
              }}
              userDetail={{
                name: item?.name || "",
                avatarUrl: item?.avatarUrl || "",
                userPhoneNumber: item?.phoneNumber,
              }}
            />
          </div>
        )
      })}
    </div>
  )
}

export default TicketCollection
